import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import qs from 'query-string';

export const defaultLocale = 'en';

export const getLocale = (): string => {
  if (typeof window === 'undefined') {
    return defaultLocale;
  }
  if (!window.AzarJs || !window.AzarJs.getUiLocale) {
    const parsed = qs.parse(window.location.search);
    return (parsed.lang as string) || defaultLocale;
  }
  return window.AzarJs.getUiLocale();
};

export const convertToCrowdinLocale = (rawLocale: string) => {
  if (!rawLocale) return defaultLocale;
  const [locale, country] = rawLocale.replace(/-/gi, '_').split('_');
  const countryCode = country && country.toUpperCase();
  switch (locale) {
    case 'zh':
      if (['TW', 'HANT'].includes(countryCode)) {
        // 번체
        return 'zh_rTW';
      }
      return 'zh_CN'; // 간체
    case 'pt':
      if (countryCode === 'BR') {
        return 'pt_BR';
      }
      break;
    case 'es':
      if (countryCode === 'MX') {
        return 'es_MX';
      }
      break;
    case 'in':
      return 'id';
    default:
      return locale;
  }
  return locale;
};

export const initializeI18next = async (locale: string) => {
  i18next
    .use(Backend)
    .use(initReactI18next)
    .init({
      initImmediate: false,
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
        prefix: '{',
        suffix: '}',
      },
      contextSeparator: '/',
      pluralSeparator: '.',
      nonExplicitSupportedLngs: true,
      keySeparator: false,
      lng: locale,
      backend: {
        loadPath: `/translations/messages/${locale}/strings.json`,
      },
    });
  i18next.services.pluralResolver.addRule('ar', {
    numbers: [1, 2],
    plurals: (n: number) => Number(n !== 1),
  });

  return i18next;
};
